<template>
  <div :class="$style.layout">
    <div class="w-[1200px] mx-auto relative" :class="mainWidth">
      <div v-if="$slots.header" :class="$style.header">
        <slot name="header" />
      </div>

      <div :class="[$style.main, mainClass]">
        <div :class="$style.content">
          <slot />
        </div>

        <div :class="$style.aside">
          <slot name="aside" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewLayout",
  props: {
    mainClass: String,
    mainWidth: String
  }
};
</script>
<style lang="scss" module>
.layout {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 4rem;
}
.main {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-bottom: 4rem;
}
.content {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
}
.aside {
  margin-left: 2rem;
  width: 310px;
}
</style>